import { api, makeGetQueryFn, makeMutationFn } from 'shared/api';

import { CandidateViewModel, UpdateCandidateProfileRequest } from './types';

export const fetchCandidateProfile = async () => {
    return await api.get<CandidateViewModel>(
        '/candidatePortal/candidates/profile'
    );
};

export const queryFetchCandidateProfile = makeGetQueryFn<CandidateViewModel>(
    () => api.get<CandidateViewModel>('/candidatePortal/candidates/profile')
);

export const updateCandidateProfile = makeMutationFn<
    UpdateCandidateProfileRequest,
    CandidateViewModel
>(
    (payload) => api.put<UpdateCandidateProfileRequest, CandidateViewModel>(
        '/candidatePortal/candidates/profile',
        payload
    )
);
